const physicalToLogicalAlignmentMap = {
    left: 'start',
    center: 'center',
    right: 'end',
};
const directionToLogicalAlignmentMap = {
    ltr: 'start',
    rtl: 'end',
};
export const castToInheritIfNeeded = (value, parentValue) => (value === parentValue ? 'inherit' : value);
export const castFromInheritIfNeeded = (value, parentValue) => (!value || value === 'inherit' ? parentValue : value);
export const convertPhysicalAlignmentToLogical = (physicalAlignment) => physicalToLogicalAlignmentMap[physicalAlignment];
export const convertDirectionToLogicalAlignment = (direction) => directionToLogicalAlignmentMap[direction];
export const getOppositeAlign = (align) => align === 'start' ? 'end' : 'start';
export const convertDirectionToFlexDirection = (direction) => {
    return direction === 'rtl' ? 'rowReverse' : 'row';
};
export const getOppositeFlexDirection = (flexDirection) => {
    if (flexDirection.startsWith('row')) {
        return flexDirection === 'row' ? 'rowReverse' : 'row';
    }
    return flexDirection === 'column' ? 'columnReverse' : 'column';
};
export const convertFlexDirectionToCssFlexDirection = (flexDirection) => {
    switch (flexDirection) {
        case 'rowReverse':
            return 'row-reverse';
        case 'columnReverse':
            return 'column-reverse';
        default:
            return flexDirection;
    }
};
//# sourceMappingURL=utils.js.map